import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import getNumberOfLayers from "../../../../service/getNumberOfLayers"
import type EstimateValues from "../../../../types/params"

const replaceBonding = (values: EstimateValues) => {
  const isDisplayed = getDisplayCondition(values)
  const numberOfLayers = getNumberOfLayers(values)

  if (isDisplayed.rfContactPortionCnt && isDisplayed.reinForcementCnt) {
    const getNext = (value: string) => {
      switch (value) {
        case ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(片面)"].value:
        case ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(2層)"].value:
        case ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(3層)"].value:
        case ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(4層)"].value:
          if (numberOfLayers === 1) return ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(片面)"].value
          if (numberOfLayers === 2) return ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(2層)"].value
          if (numberOfLayers === 3) return ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(3層)"].value
          if (numberOfLayers === 4) return ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(4層)"].value
          break

        case ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(片面)"].value:
        case ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(2層)"].value:
        case ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(3層)"].value:
        case ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(4層)"].value:
          if (numberOfLayers === 1) return ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(片面)"].value
          if (numberOfLayers === 2) return ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(2層)"].value
          if (numberOfLayers === 3) return ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(3層)"].value
          if (numberOfLayers === 4) return ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(4層)"].value
          break
      }

      return value
    }

    return {
      reinForcementBonding1: getNext(values.reinForcementBonding1),
      reinForcementBonding2: getNext(values.reinForcementBonding2),
      rfContactPortionBonding1: getNext(values.rfContactPortionBonding1),
      rfContactPortionBonding2: getNext(values.rfContactPortionBonding2),
    }
  }

  return {
    reinForcementBonding1: values.reinForcementBonding1,
    reinForcementBonding2: values.reinForcementBonding2,
    rfContactPortionBonding1: values.rfContactPortionBonding1,
    rfContactPortionBonding2: values.rfContactPortionBonding2,
  }
}

export default replaceBonding
